<template>
  <InputSelect
    :error-fields="errorFields"
    :model-value="modelValue"
    :name="name"
    :options="categories"
    :submitted="submitted"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    Categoria
  </InputSelect>
</template>

<script setup>
import useAxios from "@/composables/axios";

import InputSelect from './InputSelect.vue';

defineProps({
  errorFields: {
    type: Object,
    required: true
  },
  submitted: {
    type: Boolean,
    required: true
  },
  name: {
    type: String,
    required: true
  },
  modelValue: {
    type: String,
    default: null
  }
})

defineEmits(['update:modelValue'])

const axios = useAxios()

const categoriesResp = await axios.get('/category/list')
const categories = categoriesResp.data.map((category) => {
  return {
    id: category.uuid,
    label: category.code
  }
})

</script>